/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdNameResultOfint } from './IdNameResultOfint';
import {
    IdNameResultOfintFromJSON,
    IdNameResultOfintFromJSONTyped,
    IdNameResultOfintToJSON,
    IdNameResultOfintToJSONTyped,
} from './IdNameResultOfint';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { BalanceLineType } from './BalanceLineType';
import {
    BalanceLineTypeFromJSON,
    BalanceLineTypeFromJSONTyped,
    BalanceLineTypeToJSON,
    BalanceLineTypeToJSONTyped,
} from './BalanceLineType';

/**
 * 
 * @export
 * @interface CalculationCycleDetailResponse
 */
export interface CalculationCycleDetailResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof CalculationCycleDetailResponse
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof CalculationCycleDetailResponse
     */
    calculationCycleId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof CalculationCycleDetailResponse
     */
    transactionCode: string;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof CalculationCycleDetailResponse
     */
    member: IdNameResultOfint;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof CalculationCycleDetailResponse
     */
    student: IdNameResultOfint;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof CalculationCycleDetailResponse
     */
    _class: IdNameResultOfint | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof CalculationCycleDetailResponse
     */
    location: IdNameResultOfint | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof CalculationCycleDetailResponse
     */
    season: IdNameResultOfint | null;
    /**
     * 
     * @type {number}
     * @memberof CalculationCycleDetailResponse
     */
    amount: number;
    /**
     * 
     * @type {BalanceLineType}
     * @memberof CalculationCycleDetailResponse
     */
    lineType: BalanceLineType | null;
    /**
     * 
     * @type {string}
     * @memberof CalculationCycleDetailResponse
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculationCycleDetailResponse
     */
    note: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CalculationCycleDetailResponse
     */
    isSynced: boolean | null;
}



/**
 * Check if a given object implements the CalculationCycleDetailResponse interface.
 */
export function instanceOfCalculationCycleDetailResponse(value: object): value is CalculationCycleDetailResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('calculationCycleId' in value) || value['calculationCycleId'] === undefined) return false;
    if (!('transactionCode' in value) || value['transactionCode'] === undefined) return false;
    if (!('member' in value) || value['member'] === undefined) return false;
    if (!('student' in value) || value['student'] === undefined) return false;
    if (!('_class' in value) || value['_class'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('season' in value) || value['season'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('lineType' in value) || value['lineType'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('isSynced' in value) || value['isSynced'] === undefined) return false;
    return true;
}

export function CalculationCycleDetailResponseFromJSON(json: any): CalculationCycleDetailResponse {
    return CalculationCycleDetailResponseFromJSONTyped(json, false);
}

export function CalculationCycleDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculationCycleDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
        'calculationCycleId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['calculationCycleId']),
        'transactionCode': json['transactionCode'],
        'member': IdNameResultOfintFromJSON(json['member']),
        'student': IdNameResultOfintFromJSON(json['student']),
        '_class': IdNameResultOfintFromJSON(json['class']),
        'location': IdNameResultOfintFromJSON(json['location']),
        'season': IdNameResultOfintFromJSON(json['season']),
        'amount': json['amount'],
        'lineType': BalanceLineTypeFromJSON(json['lineType']),
        'description': json['description'],
        'note': json['note'],
        'isSynced': json['isSynced'],
    };
}

export function CalculationCycleDetailResponseToJSON(json: any): CalculationCycleDetailResponse {
    return CalculationCycleDetailResponseToJSONTyped(json, false);
}

export function CalculationCycleDetailResponseToJSONTyped(value?: CalculationCycleDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
        'calculationCycleId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['calculationCycleId']),
        'transactionCode': value['transactionCode'],
        'member': IdNameResultOfintToJSON(value['member']),
        'student': IdNameResultOfintToJSON(value['student']),
        'class': IdNameResultOfintToJSON(value['_class']),
        'location': IdNameResultOfintToJSON(value['location']),
        'season': IdNameResultOfintToJSON(value['season']),
        'amount': value['amount'],
        'lineType': BalanceLineTypeToJSON(value['lineType']),
        'description': value['description'],
        'note': value['note'],
        'isSynced': value['isSynced'],
    };
}

